// extracted by css-extract-rspack-plugin
export default {"message":"_30e562d","error":"_530139fe","noBorder":"_3f77e26b","hiddenPlaceholder":"_1c3298f"};